'use client';

import { useContext, useEffect } from 'react';

import { FilterPageContext, useFilterDrawer } from '../../context';
import { Facet as FacetType } from '../../types';

export default function MobileFilters({
  facets,
  productCount
}: {
  facets: FacetType[];
  productCount: number;
}) {
  const { setDrawerContent } = useFilterDrawer();
  const filterPageContextValue = useContext(FilterPageContext);

  useEffect(() => {
    setDrawerContent(
      filterPageContextValue && {
        ...filterPageContextValue,
        facets,
        productCount
      }
    );
  }, [facets, filterPageContextValue, productCount, setDrawerContent]);

  return <></>;
}
